import { ElementState } from "@creatomate/preview";
import { ElementSource } from "chq";
import getLanguageCode from "./getLanguageCode";

const getJsonSubtitleLanguages = (
  subtitleElements: ElementState[] | ElementSource[]
): string[] => {
  const languages: string[] = [];

  subtitleElements.forEach(element => {
    // Check if element is ElementState or ElementSource
    const source = "source" in element ? element.source : element;
    const [_prefix, _index, language, languageCodeOrId] = source.name.split("-", 4);
    const languageCode = getLanguageCode(language, languageCodeOrId);

    if (languageCode && !languages.includes(languageCode)) languages.push(languageCode);
  });
  return languages;
};

export default getJsonSubtitleLanguages;
